import React, { useCallback, useEffect, useState } from 'react';
import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import { ConfirmationDialog } from '../components/organisms/ConfirmationDialog';
import { TrainsBrowseWindow } from '../components/organisms/Maintenance/BrowseWindow/TrainsBrowseWindow';
import TrainsCreateWindow from '../components/organisms/Maintenance/CreateWindow/TrainsCreateWindow';
import TrainsEditWindow from '../components/organisms/Maintenance/EditWindow/TrainsEditWindow';
import {
  MaintenanceHeader,
  selectTabEnum
} from '../components/organisms/Maintenance/MaintenanceHeader';
import { MaintenanceTitle } from '../components/organisms/Maintenance/MaintenanceTitle';
import TrainsSearchBox from '../components/organisms/Maintenance/SearchWindow/TrainsSearchBox';
import {
  MainteTrainsType,
  MaintenanceTrainsTable
} from '../components/organisms/Maintenance/Table/MaintenanceTrainsTable';
import { DeleteTrainsApi } from '../apis/DeleteMaintenance.api';
import { GetTrainsApi } from '../apis/GetMaintenance.api';
import { QueryTrainsApi } from '../apis/QueryMaintenance.api';
import { TrainGroupsNameType } from '../apis/ApiClient';
import { chooseDataStateType } from '../components/molecules/MaintenanceModalDispLabels';

const MainteTrainsApiTag = 'trains';

export type TrainsStateType = {
  type: 'trains';
  trains: MainteTrainsType;
};

export interface TrainsSearchCondition {
  sort: { key: string; sortType: boolean };
  trainNumber: { compare: string; number: string };
  model: string;
  dateCreatedFrom: string;
  dateCreatedTo: string;
  dateUpdatedFrom: string;
  dateUpdatedTo: string;
}

export type TrainsArrayStateType = {
  type: 'trains';
  trains: MainteTrainsType[] | undefined;
};

export const TrainsMaintenance: React.FC = () => {
  const [query, setQuery] = useState<TrainsSearchCondition>({
    sort: { key: '', sortType: false },
    trainNumber: { compare: '1', number: '' },
    model: '',
    dateCreatedFrom: '',
    dateCreatedTo: '',
    dateUpdatedFrom: '',
    dateUpdatedTo: ''
  });

  const stateUpdate = (data: chooseDataStateType) => {
    if (data.type === MainteTrainsApiTag) {
      setChooseData(data.trains);
    }
  };
  const DeleteApi = async () => {
    if (chooseData?.id !== undefined) {
      const response = await DeleteTrainsApi(chooseData.id);
      if (response.success) {
        setMaintenanceDatas(response.data as MainteTrainsType[]);
        CreateOrUpdateStateSwitch();
      }
    }
  };
  const {
    isOpen: isOpenCreate,
    onOpen: onOpenCreate,
    onClose: onCloseCreate
  } = useDisclosure();
  const {
    isOpen: isOpenBrowse,
    onOpen: onOpenBrowse,
    onClose: onCloseBrowse
  } = useDisclosure();
  const {
    isOpen: isOpenEdit,
    onOpen: onOpenEdit,
    onClose: onCloseEdit
  } = useDisclosure();
  const {
    isOpen: isOpenConfirm,
    onOpen: onToggle,
    onClose: onCloseConfirm
  } = useDisclosure();
  const [chooseData, setChooseData] = useState<MainteTrainsType>();
  const [maintenanceDatas, setMaintenanceDatas] = useState<
    MainteTrainsType[] | undefined
  >();
  const [trainGroupsDatas, setTrainGroupsDatas] = useState<
    TrainGroupsNameType[] | undefined
  >();

  const [createOrUpdate, setCreateOrUpdate] = useState(false);

  const CreateOrUpdateStateSwitch = useCallback(() => {
    setQuery({
      sort: { key: '', sortType: false },
      trainNumber: { compare: '1', number: '' },
      model: '',
      dateCreatedFrom: '',
      dateCreatedTo: '',
      dateUpdatedFrom: '',
      dateUpdatedTo: ''
    });
    setCreateOrUpdate(!createOrUpdate);
  }, [createOrUpdate]);

  const [searchSwitch, setSearchSwitch] = useState(false);

  const SearchStateSwitch = useCallback(() => {
    setSearchSwitch(!searchSwitch);
  }, [searchSwitch]);

  const GetApi = async () => {
    const trainsResponse = await GetTrainsApi();
    if (trainsResponse.success) {
      setMaintenanceDatas(trainsResponse.data as MainteTrainsType[]);
    }
    const trainGroupsResponse = await QueryTrainsApi('/train_groups');
    if (trainGroupsResponse.success) {
      setTrainGroupsDatas(trainGroupsResponse.data as TrainGroupsNameType[]);
    }
  };

  useEffect(() => {
    GetApi();
  }, []);

  return (
    <>
      <Flex direction='column' h='100vh'>
        <MaintenanceHeader selectTab={selectTabEnum.Trains} />
        <MaintenanceTitle
          selectTab={selectTabEnum.Trains}
          onOpen={onOpenCreate}
        />
        <Box
          position='relative'
          display='grid'
          gridTemplateRows='0.1fr 2fr 0.1fr'
          gridTemplateColumns='3fr 1fr'
          h='100%'
        >
          <MaintenanceTrainsTable
            TrainsDatas={maintenanceDatas}
            setMaintenanceDatas={setMaintenanceDatas}
            setChooseData={stateUpdate}
            onOpenBrowse={onOpenBrowse}
            onOpenEdit={onOpenEdit}
            onToggle={onToggle}
            Query={query}
            setQuery={setQuery}
            createOrUpdate={createOrUpdate}
            searchSwitch={searchSwitch}
          />

          <TrainsSearchBox
            setMaintenanceDatas={setMaintenanceDatas}
            TrainGroupsDatas={trainGroupsDatas}
            Query={query}
            setQuery={setQuery}
            createOrUpdate={createOrUpdate}
            SearchStateSwitch={SearchStateSwitch}
          />

          {isOpenCreate && (
            <TrainsCreateWindow
              isOpen={isOpenCreate}
              onClose={onCloseCreate}
              TrainGroupsDatas={trainGroupsDatas}
              setMaintenanceDatas={setMaintenanceDatas}
              CreateOrUpdateStateSwitch={CreateOrUpdateStateSwitch}
            />
          )}

          {isOpenBrowse && (
            <TrainsBrowseWindow
              isOpen={isOpenBrowse}
              onClose={onCloseBrowse}
              BrowseData={chooseData}
            />
          )}

          {isOpenEdit && (
            <TrainsEditWindow
              isOpen={isOpenEdit}
              onClose={onCloseEdit}
              EditData={chooseData}
              TrainGroupsDatas={trainGroupsDatas}
              setMaintenanceDatas={setMaintenanceDatas}
              CreateOrUpdateStateSwitch={CreateOrUpdateStateSwitch}
            />
          )}
          {isOpenConfirm && (
            <ConfirmationDialog
              isOpen={isOpenConfirm}
              onClose={onCloseConfirm}
              dispMessage={'本当に削除しますか？'}
              DeleteApi={DeleteApi}
            />
          )}
        </Box>
      </Flex>
    </>
  );
};
